import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Translate } from 'react-localize-redux';

interface NoPecChipProps {
    /** `bill.pecMissing` from the API. Only `true` renders; null means the PECs were not loaded. */
    pecMissing?: boolean | null;
}

/**
 * SHER-934 — marks a patient invoice billed to an insurer that has no PEC. Informational
 * only: nothing is blocked on it. Which invoices qualify (and the PAF/Particulier, PAL and
 * Personnel exemptions) is decided by the API, never re-derived here.
 */
const NoPecChip: React.FC<NoPecChipProps> = ({ pecMissing }) => {
    if (pecMissing !== true) {
        return null;
    }
    return (
        <Tooltip title={<Translate id="hospital.billing.no_pec_hint" />}>
            <Chip
                label={<Translate id="hospital.billing.no_pec" />}
                color="warning"
                variant="outlined"
                size="small"
            />
        </Tooltip>
    );
};

export default NoPecChip;
